import React from 'react'
import './HeaderTitlewithBack.css'
import { useNavigate } from 'react-router-dom';

export default function HeaderTitlewithBack({ title }) {
    const navigate = useNavigate();
    return (
        <div>
            <div className="header-top-title">
                <div className="header-top-title-left" onClick={() => {
                    if (window.history.state && window.history.state.idx > 0) {
                        navigate(-1);
                    } else {
                        navigate('/');
                    }
                }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none">
                        <path
                            d="M17 7H1M1 7L7 1M1 7L7 13"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    {title}
                </div>
            </div>
        </div>
    )
}
